import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Card, CardHeader, CardBody, Button, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MetaConnectSelect = () => {
  const history = useHistory();
  const location = useLocation();
  const { token: authToken, userLanguage } = useSelector((state) => state.auth);
  const t = {
    couldNotLoad: { en: "Could not load Meta accounts", fr: "Impossible de charger les comptes Meta", es: "No se pudieron cargar las cuentas de Meta", zh: "无法加载Meta账户", pt: "Nao foi possivel carregar contas Meta", ar: "تعذر تحميل حسابات ميتا" },
    noAccountDetected: { en: "Could not determine an ad account to connect. Please connect again.", fr: "Impossible de determiner un compte publicitaire. Reconnectez-vous.", es: "No se pudo determinar una cuenta publicitaria. Vuelve a conectar.", zh: "无法确定要连接的广告账户，请重新连接。", pt: "Nao foi possivel determinar uma conta de anuncios. Conecte novamente.", ar: "تعذر تحديد حساب إعلاني للربط. يرجى إعادة الربط." },
    connected: { en: "Meta account connected", fr: "Compte Meta connecte", es: "Cuenta de Meta conectada", zh: "Meta账户已连接", pt: "Conta Meta conectada", ar: "تم ربط حساب ميتا" },
    connectFailed: { en: "Connect failed", fr: "Echec de connexion", es: "Conexion fallida", zh: "连接失败", pt: "Falha na conexao", ar: "فشل الاتصال" },
    loginToConnect: { en: "Please log in to connect your Meta account.", fr: "Veuillez vous connecter pour lier votre compte Meta.", es: "Inicia sesion para conectar tu cuenta de Meta.", zh: "请登录以连接您的Meta账户。", pt: "Faca login para conectar sua conta Meta.", ar: "يرجى تسجيل الدخول لربط حساب ميتا." },
    login: { en: "Log in", fr: "Se connecter", es: "Iniciar sesion", zh: "登录", pt: "Entrar", ar: "تسجيل الدخول" },
    couldNotStart: { en: "Could not start Meta connect", fr: "Impossible de demarrer la connexion Meta", es: "No se pudo iniciar la conexion con Meta", zh: "无法开始Meta连接", pt: "Nao foi possivel iniciar a conexao Meta", ar: "تعذر بدء اتصال ميتا" },
    titleConnect: { en: "Connect Meta account", fr: "Connecter le compte Meta", es: "Conectar cuenta de Meta", zh: "连接Meta账户", pt: "Conectar conta Meta", ar: "ربط حساب ميتا" },
    intro: { en: "Connect your Meta (Facebook) account to advertise. You will log in with Facebook and then choose which ad account to use.", fr: "Connectez votre compte Meta (Facebook) pour faire de la publicite. Vous vous connecterez via Facebook puis choisirez le compte publicitaire.", es: "Conecta tu cuenta de Meta (Facebook) para anunciar. Iniciaras sesion con Facebook y luego elegiras la cuenta publicitaria.", zh: "连接您的Meta（Facebook）账户以投放广告。您将通过Facebook登录，然后选择要使用的广告账户。", pt: "Conecte sua conta Meta (Facebook) para anunciar. Voce fara login com o Facebook e depois escolhera a conta de anuncios.", ar: "اربط حساب ميتا (فيسبوك) للإعلان. ستسجل الدخول عبر فيسبوك ثم تختار حساب الإعلانات." },
    redirecting: { en: "Redirecting...", fr: "Redirection...", es: "Redirigiendo...", zh: "正在跳转...", pt: "Redirecionando...", ar: "جارٍ إعادة التوجيه..." },
    backProducts: { en: "Back to Products", fr: "Retour aux produits", es: "Volver a Productos", zh: "返回产品页", pt: "Voltar aos produtos", ar: "العودة إلى المنتجات" },
    loadingAccounts: { en: "Loading your Meta accounts...", fr: "Chargement de vos comptes Meta...", es: "Cargando tus cuentas de Meta...", zh: "正在加载您的Meta账户...", pt: "Carregando suas contas Meta...", ar: "جارٍ تحميل حسابات ميتا الخاصة بك..." },
    titleConfirm: { en: "Confirm Meta connection", fr: "Confirmer la connexion Meta", es: "Confirmar conexion de Meta", zh: "确认Meta连接", pt: "Confirmar conexao Meta", ar: "تأكيد ربط ميتا" },
    noAccounts: { en: "No ad accounts found, or this link expired. Create an ad account in Meta Business Manager, then connect again.", fr: "Aucun compte publicitaire trouve ou lien expire. Creez un compte dans Meta Business Manager puis reconnectez.", es: "No se encontraron cuentas publicitarias o el enlace caduco. Crea una cuenta en Meta Business Manager y vuelve a conectar.", zh: "未找到广告账户，或此链接已过期。请在Meta商务管理平台创建广告账户后重试。", pt: "Nenhuma conta de anuncios encontrada ou link expirado. Crie uma conta no Meta Business Manager e conecte novamente.", ar: "لم يتم العثور على حسابات إعلانية أو انتهت صلاحية الرابط. أنشئ حسابًا في مدير أعمال ميتا ثم أعد الربط." },
    foundPages: { en: "We found your connected Facebook Page(s). Click Continue to finish connecting Meta.", fr: "Nous avons trouve vos pages Facebook connectees. Cliquez sur Continuer pour terminer.", es: "Encontramos tus paginas de Facebook conectadas. Haz clic en Continuar para finalizar.", zh: "我们找到了您已连接的Facebook页面。点击继续完成连接。", pt: "Encontramos suas paginas do Facebook conectadas. Clique em Continuar para finalizar.", ar: "عثرنا على صفحات فيسبوك المتصلة. اضغط متابعة لإكمال الربط." },
    fbPage: { en: "Facebook Page", fr: "Page Facebook", es: "Pagina de Facebook", zh: "Facebook页面", pt: "Pagina do Facebook", ar: "صفحة فيسبوك" },
    noPages: { en: "No Pages were returned by Meta. You can still continue, but campaign creation will require adding a Page manually.", fr: "Aucune page renvoyee par Meta. Vous pouvez continuer, mais il faudra ajouter une page manuellement.", es: "Meta no devolvio paginas. Puedes continuar, pero crear campanas requerira agregar una pagina manualmente.", zh: "Meta未返回页面。您仍可继续，但创建广告活动时需手动添加页面。", pt: "Nenhuma pagina retornada pela Meta. Voce pode continuar, mas a criacao exigira adicionar uma pagina manualmente.", ar: "لم تُرجع ميتا أي صفحات. يمكنك المتابعة، لكن إنشاء الحملات سيتطلب إضافة صفحة يدويًا." },
    page: { en: "Page", fr: "Page", es: "Pagina", zh: "页面", pt: "Pagina", ar: "صفحة" },
    primary: { en: "primary", fr: "principale", es: "principal", zh: "主要", pt: "principal", ar: "أساسية" },
    continuing: { en: "Continuing...", fr: "Continuation...", es: "Continuando...", zh: "继续中...", pt: "Continuando...", ar: "جارٍ المتابعة..." },
    continue: { en: "Continue", fr: "Continuer", es: "Continuar", zh: "继续", pt: "Continuar", ar: "متابعة" },
    cancel: { en: "Cancel", fr: "Annuler", es: "Cancelar", zh: "取消", pt: "Cancelar", ar: "إلغاء" },
  };
  const [token, setToken] = useState("");
  const [adAccounts, setAdAccounts] = useState([]);
  const [pages, setPages] = useState([]);
  const [existingAccountId, setExistingAccountId] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [connectLoading, setConnectLoading] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState("");

  useEffect(() => {
    if (!authToken) return;
    axios
      .get("/ad-accounts", { headers: { Authorization: `Bearer ${authToken}` } })
      .then((res) => {
        const first = (res.data?.data || [])[0];
        const acct = first?.accountId || "";
        setExistingAccountId(acct);
      })
      .catch(() => setExistingAccountId(""));
  }, [authToken]);

  useEffect(() => {
    const params = new URLSearchParams(location.search || "");
    const t = params.get("token") || "";
    setToken(t);
    if (!t) {
      setLoading(false);
      return;
    }
    if (!authToken) {
      setLoading(false);
      return;
    }
    axios
      .get(`/auth/meta-ads/pending-accounts?token=${encodeURIComponent(t)}`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        const list = res.data.adAccounts || [];
        setAdAccounts(list);
        const p = res.data.pages || [];
        setPages(p);

        // Auto-select account (prefer already-connected ad account id, otherwise first available).
        const normalizedExisting = String(existingAccountId || "").trim();
        const match =
          normalizedExisting && list.find((a) => String(a.id) === normalizedExisting);
        if (match) setSelectedAccountId(match.id);
        else if (list.length > 0) setSelectedAccountId(list[0].id);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || t.couldNotLoad[userLanguage] || t.couldNotLoad.en);
        setAdAccounts([]);
        setPages([]);
      })
      .finally(() => setLoading(false));
  }, [location.search, authToken, existingAccountId]);

  const handleConnect = () => {
    if (!token || !selectedAccountId) {
      toast.error(t.noAccountDetected[userLanguage] || t.noAccountDetected.en);
      return;
    }
    setSubmitting(true);
    axios
      .post(
        "/auth/meta-ads/confirm-account",
        { token, accountId: selectedAccountId },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then(() => {
        toast.success(t.connected[userLanguage] || t.connected.en);
        history.push("/seller/products?meta_connected=1");
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || t.connectFailed[userLanguage] || t.connectFailed.en);
        setSubmitting(false);
      });
  };

  if (!authToken) {
    return (
      <div className="animated fadeIn p-4">
        <Card>
          <CardBody>
            <p>{t.loginToConnect[userLanguage] || t.loginToConnect.en}</p>
            <Button color="primary" onClick={() => history.push("/auth/login")}>
              {t.login[userLanguage] || t.login.en}
            </Button>
          </CardBody>
        </Card>
      </div>
    );
  }

  const startConnect = () => {
    setConnectLoading(true);
    axios
      .get("/auth/meta-ads/connect", { headers: { Authorization: `Bearer ${authToken}` } })
      .then((res) => {
        if (res.data && res.data.url) {
          window.location.href = res.data.url;
          return;
        }
        setConnectLoading(false);
        toast.error(res.data?.message || t.couldNotStart[userLanguage] || t.couldNotStart.en);
      })
      .catch((err) => {
        setConnectLoading(false);
        toast.error(err.response?.data?.message || t.connectFailed[userLanguage] || t.connectFailed.en);
      });
  };

  if (!token) {
    return (
      <div className="animated fadeIn p-4">
        <ToastContainer />
        <Card>
          <CardHeader><b>{t.titleConnect[userLanguage] || t.titleConnect.en}</b></CardHeader>
          <CardBody>
            <p>{t.intro[userLanguage] || t.intro.en}</p>
            <Button color="primary" onClick={startConnect} disabled={connectLoading}>
              {connectLoading ? t.redirecting[userLanguage] || t.redirecting.en : t.titleConnect[userLanguage] || t.titleConnect.en}
            </Button>
            <Button color="secondary" className="ml-2" onClick={() => history.push("/seller/products")}>
              {t.backProducts[userLanguage] || t.backProducts.en}
            </Button>
          </CardBody>
        </Card>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="animated fadeIn p-4 text-center">
        <i className="fas fa-spinner fa-pulse fa-2x" style={{ color: "var(--primary)" }} aria-hidden />
        <p className="mt-2">{t.loadingAccounts[userLanguage] || t.loadingAccounts.en}</p>
      </div>
    );
  }

  return (
    <div className="animated fadeIn">
      <ToastContainer />
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <b>{t.titleConfirm[userLanguage] || t.titleConfirm.en}</b>
            </CardHeader>
            <CardBody>
              {adAccounts.length === 0 ? (
                <>
                  <p className="text-muted">{t.noAccounts[userLanguage] || t.noAccounts.en}</p>
                  <Button color="primary" onClick={startConnect} disabled={connectLoading}>
                    {connectLoading ? t.redirecting[userLanguage] || t.redirecting.en : t.titleConnect[userLanguage] || t.titleConnect.en}
                  </Button>
                  <Button color="secondary" className="ml-2" onClick={() => history.push("/seller/products")}>
                    {t.backProducts[userLanguage] || t.backProducts.en}
                  </Button>
                </>
              ) : (
                <>
                  <p>{t.foundPages[userLanguage] || t.foundPages.en}</p>

                  <FormGroup>
                    <Label>{t.fbPage[userLanguage] || t.fbPage.en}</Label>
                    {pages.length === 0 ? (
                      <div className="text-muted">
                        {t.noPages[userLanguage] || t.noPages.en}
                      </div>
                    ) : (
                      <div>
                        {pages.map((p) => (
                          <div key={p.pageId}>
                            <b>{p.pageName || t.page[userLanguage] || t.page.en}</b> <span className="text-muted">({p.pageId})</span>
                            {p.isPrimary ? <span className="text-muted"> — {t.primary[userLanguage] || t.primary.en}</span> : null}
                          </div>
                        ))}
                      </div>
                    )}
                  </FormGroup>

                  <Button color="primary" onClick={handleConnect} disabled={submitting}>
                    {submitting ? t.continuing[userLanguage] || t.continuing.en : t.continue[userLanguage] || t.continue.en}
                  </Button>
                  <Button color="secondary" className="ml-2" onClick={() => history.push("/seller/products")}>
                    {t.cancel[userLanguage] || t.cancel.en}
                  </Button>
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default MetaConnectSelect;
